<template>
    <span>Token Renewed</span>
</template>

<script>
import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc'
import { OidcSettings } from '@/config/oidc'

export default {
    name: "OidcSilentRenewCallback",
    data() {
        return { }
    },
    mounted() {
        vuexOidcProcessSilentSignInCallback(OidcSettings);
    }
}
</script>